/**
 * Present a wire decimal STRING as dollars without ever converting it to a JavaScript number.
 * Unknown future wire shapes remain visible verbatim instead of being rounded or discarded.
 */
export function formatMoneyDisplay(value: string | null | undefined): string {
  if (value == null || value === '') return '—';
  const match = /^([+-]?)(\d+)(?:\.(\d+))?$/.exec(value.trim());
  if (!match) return value;
  const sign = match[1] === '-' ? '-' : '';
  let integer = (match[2] ?? '0').replace(/^0+(?=\d)/, '');
  const fraction = match[3] ?? '';
  let cents = fraction.slice(0, 2).padEnd(2, '0');

  if (fraction.charCodeAt(2) - 48 >= 5) {
    const carried = addOneToDigits(integer + cents);
    integer = carried.slice(0, -2);
    cents = carried.slice(-2);
  }

  let grouped = '';
  for (let index = 0; index < integer.length; index += 1) {
    if (index > 0 && (integer.length - index) % 3 === 0) grouped += ',';
    grouped += integer[index]!;
  }
  return `$${sign}${grouped}.${cents}`;
}

function addOneToDigits(digits: string): string {
  const output = digits.split('');
  let carry = 1;
  for (let index = output.length - 1; index >= 0 && carry > 0; index -= 1) {
    const sum = output[index]!.charCodeAt(0) - 48 + carry;
    output[index] = String.fromCharCode((sum % 10) + 48);
    carry = sum >= 10 ? 1 : 0;
  }
  return carry > 0 ? `1${output.join('')}` : output.join('');
}
